module.exports = {
  COMPANY_NAME: "eSanchari",
  // API_INSTANCE: 'http://localhost:5000',
  // API_CONTEXT_URL: 'http://localhost:5000' + '/api/v1/public'
  // API_INSTANCE: 'https://dggc6swr8a0nq.cloudfront.net', // dev
  // API_CONTEXT_URL: 'https://dggc6swr8a0nq.cloudfront.net' + '/api/v1/public' // dev
  API_INSTANCE: 'https://dbf8t0rwdx2gy.cloudfront.net', //prod
  API_CONTEXT_URL: 'https://dbf8t0rwdx2gy.cloudfront.net' + '/api/v1/public' //prod
}
